import { IApplicationState } from '../../../common/types/redux';

export const selectActiveOfferId = (state: IApplicationState): number | null => {
  return state.map.selection?.realtyId ?? null;
};
